/**
 * vistor上监听事件集合
 * */

type EventName = 'after-vistor-login' | 'after-vistor-logout';
const getList = Symbol('getVistorEvents');
type Callback = (params?: any) => void;
interface Listener extends Callback {
  once?: boolean;
}
type Listeners = Record<EventName, Array<Listener>>;
class VistorEventBus {
  listeners: Listeners;
  constructor() {
    this.listeners = {
      'after-vistor-login': [],
      'after-vistor-logout': [],
    };
  }
  [getList](action: EventName): Array<Listener> {
    if (!this.listeners[action]) {
      this.listeners[action] = [];
    }
    return this.listeners[action];
  }
  public on(action: 'after-vistor-login', callback: () => void): VistorEventBus;
  public on(action: 'after-vistor-logout', callback: () => void): VistorEventBus;
  public on(action: EventName, callback: Listener): VistorEventBus;
  public on(action: EventName, callback: Listener): VistorEventBus {
    this[getList](action).push(callback);
    return this;
  }
  once(action: EventName, callback: Listener): VistorEventBus {
    if (!callback) return this;
    const listener = callback;
    listener.once = true;
    this.on(action, listener);
    return this;
  }
  off(action: EventName, callback: Listener | '*'): VistorEventBus {
    const list = this[getList](action);
    if (callback === '*') {
      for (let i = list.length - 1; i >= 0; i -= 1) {
        list.splice(i, 1);
      }
    } else {
      for (let i = list.length - 1; i >= 0; i -= 1) {
        if (callback === list[i]) {
          list.splice(i, 1);
        }
      }
    }
    return this;
  }
  emit(action: EventName, data?: string | object): VistorEventBus {
    const list = this[getList](action).map(cb => cb);
    for (let i = 0; i < list.length; i += 1) {
      const callback = list[i];
      callback(data);
      if (list[i].once) {
        this.off(action, list[i]);
      }
    }
    return this;
  }
}
export default VistorEventBus;
